import React from "react";
import { Table, Button } from 'react-bootstrap';
import Header from "./Header";
import Footer from "./Footer";
import { addCount, miCount, removeItem } from './../store.js';
import { ReactReduxContext, useDispatch, useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom';


const Cart = () => {
  let navigate = useNavigate();

  function total(){
    let sum = 0;
    for(let v in state.cart){
      sum += state.cart[v].price * state.cart[v].count
    }
    return sum
  }

  let dispatch = useDispatch();
  let state = useSelector((state)=>state);
  
  
  return (


    <div>

      <Header></Header>

      <div className="cart_wrap">
        <h1>장바구니 내역</h1>
        <Table striped className="cart_table">
          <thead>
            <tr>
              <th>NO.</th>
              <th>상품명</th>
              <th>가격(원)</th>
              <th>수량</th>
              <th>삭제</th>
            </tr>
          </thead>  
          <tbody>
            {
              state.cart.map((v,i)=>
              <tr key = {i}>
                <td>{state.cart[i].id}</td>
                <td>{state.cart[i].name}</td>
                <td>{((state.cart[i].price)*(state.cart[i].count)).toLocaleString()}</td>
                <td className="num">
                  <button onClick={()=>
                  dispatch(miCount(state.cart[i].id))}>	
                  －</button>
                  <span>{state.cart[i].count}</span>
                  <button onClick={()=>
                  dispatch(addCount(state.cart[i].id))}>＋</button>
                </td>
                <td className="cart_del">
                  <button onClick={()=>
                  dispatch(removeItem(state.cart[i].id))}>×</button>
                </td>
              </tr>
              )
            }
          </tbody>
        </Table>
        <div className="cart_price">
          <h2>
            결제 예상 금액 = <span>{total().toLocaleString()}</span>원
          </h2>
          <div>
            <Button variant="dark" onClick={()=>{
              alert("로그인 후 이용 가능힙니다.");
              navigate('/LOGIN');
            }}>구매하기</Button>
          </div>
        </div>
      </div>

      <Footer></Footer>

    </div>
  )
}

export default Cart;